import yup from 'src/libs/yup'

export const ProductSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  price: yup.string().required().label('Preço'),
  description: yup.string().nullable(),
})
